// import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { uiHelper } from '~/helpers/ui.helper';

declare let $;
import { translatePipe, translationHelper } from '~/helpers/translation.helper';
import { environment, getBetGeniusLiveTracker, pitchLogo } from '@env/environment';

export interface DialogData {
    tournamentId: string;
    sportId: string;
    type: string;
    betradarMatchId: string;
}
declare let SIR: any;

@Component({
    selector: 'comp_livetracker_modal',
    templateUrl: './livetracker-modal.html',
})
export class LiveTrackerModal implements OnInit, OnDestroy {
    iframe_src;

    betgeniustrackerlink: any;
    enableBetGeniusTracker = false;
    SIROBJ;

    betradarMatchId;
    subsidleResetListener;
    subsliveTrackerModalCloseListener;
    constructor(private domSanitizer: DomSanitizer, private _uiHelper: uiHelper, public translate: translationHelper) {
        this.SIROBJ = null;
        this.betgeniustrackerlink = this.domSanitizer.bypassSecurityTrustResourceUrl('about:blank');

        this._uiHelper.liveTrackerListener.subscribe(x => {
            this.betradarMatchId = x;
            if (x != 0) {
                try {
                    if (SIR != undefined) {
                        if (x > 0) {
                            this.enableBetGeniusTracker = false;
                            this.betgeniustrackerlink = this.domSanitizer.bypassSecurityTrustResourceUrl('about:blank');
                            this.SIROBJ = SIR('addWidget', '.sr-widget-1', 'match.lmtPlus', {
                                scoreboard: 'extended',
                                tabsPosition: 'top',
                                layout: 'single',
                                pitchLogo: pitchLogo,
                                matchId: x,
                            });
                        } else {
                            this.SIROBJ = null;
                            this.betgeniustrackerlink = this.domSanitizer.bypassSecurityTrustResourceUrl(
                                getBetGeniusLiveTracker(x, ''),
                            );
                            this.enableBetGeniusTracker = true;
                        }
                    }
                } catch (e) {}
            }
        });

        this.subsliveTrackerModalCloseListener = this._uiHelper.liveTrackerModalCloseListener.subscribe(x => {
            this.enableBetGeniusTracker = false;
            this.SIROBJ = null;
            this.betgeniustrackerlink = this.domSanitizer.bypassSecurityTrustResourceUrl('about:blank');
        });

        this.subsidleResetListener = this._uiHelper.idleResetListener.subscribe(s => {
            this.modalHide();
        });
    }

    ngOnInit() {}

    modalHide() {
        this.enableBetGeniusTracker = false;
        this.SIROBJ = null;
        this.betgeniustrackerlink = this.domSanitizer.bypassSecurityTrustResourceUrl('about:blank');
        $('#Livetracker_Modal').modal('hide');
    }

    OpenLiveTrackerOnSecondScreen() {
        this._uiHelper.SendElectronMessage('electronListener', {
            type: 'livetracker',
            isopen: true,
            matchid: this.betradarMatchId,
        });
        this.modalHide();
    }

    ngOnDestroy() {
        if (this.subsliveTrackerModalCloseListener != undefined) {
            this.subsliveTrackerModalCloseListener.unsubscribe();
            this.subsliveTrackerModalCloseListener = undefined;
        }
        if (this.subsidleResetListener != undefined) {
            this.subsidleResetListener.unsubscribe();
            this.subsidleResetListener = undefined;
        }
    }
}
